import { apolloQueryWrapper } from '@/shared/api';
import HOLTER_EVENT_INDEX_QUERY from '@/entities/event/api/queries/holterEventIndex';
import type {
  HolterEventIndexQuery,
  HolterEventIndexQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterEventIndex = {
  isSuccess: boolean;
  message: string;
  eventIndex: number;
};

// TODO(ts): typed as the HolterEventIndexFilter GraphQL input once its server-side shape is documented
/**
 * Loads the index position of a Holter event within its filtered list. Runs the holterEventIndex query through apolloQueryWrapper and returns its eventIndex, throwing the server message when isSuccess is false.
 *
 * @param filter - GraphQL filter identifying the event and the list it sits in.
 * @param isUsingCache - When true, lets the wrapper serve a cached result.
 * @param key - Cancellation key identifying this request.
 * @param needCancel - Whether an in-flight request under the same key is cancelled first.
 * @returns A promise resolving to the event's index in the filtered list.
 */
const fetchHolterEventIndex = async (
  filter: any,
  isUsingCache?: boolean,
  key?: string | null,
  needCancel = true,
) => {
  const result = await apolloQueryWrapper<HolterEventIndexQuery, HolterEventIndexQueryVariables>({
    options: {
      query: HOLTER_EVENT_INDEX_QUERY,
      variables: {
        filter,
      },
    },
    isUsingCache,
    key,
    needCancel,
  });
  const { data } = result;
  const { holterEventIndex } = data;
  if (holterEventIndex?.isSuccess) {
    return holterEventIndex.eventIndex;
  }
  throw new Error(holterEventIndex.message);
};

export default fetchHolterEventIndex;
